export const themeVariables = {
  space: [0, 4, 8, 12, 18, 24, 32, 48, 64, 128, 256],
  font_size_xl: 20,
  font_size_md: 14,
  font_size_sm: 12,
  spacing_md: 12,
  spacing_sm: 8,
  spacing_xs: 4,
  spacing_lg: 18,
  spacing_xl: 32,
  colors: {
    danger: "#ff4d4f",
    primary: "rgb(29,166,255)",
    base: "#EEEEEE",
    disabled: "#BDBDBD",
    white: "#fff",
    border: "#E2E2E2",
    black: "rgba(0, 0, 0, 0.65)",
    muted: "rgb(148, 148, 148)",
    grey: "rgb(148, 148, 148)",
  },
  statusColors: {
    UNDERREVIEW: "#EFC25C",
    PAID: "#08a139",
    APPROVE: "#08a139",
  }
};

export type ThemeVariables = typeof themeVariables;
